import React from 'react';

// A dark rounded panel floating inside the white home page (2026-10-15,
// "Floating islands"): a faint outer tray around an ink core, the
// double-bezel. `night` adds .theme-night to the core, which re-points every
// press-* token to its dark value, so a section built in press colours turns
// light-on-dark with no edits of its own. Leave it off for content that has to
// keep dark text (the frosted service cards).
export default function HomeDarkIsland({ children, night, className = '' }) {
  return (
    <div className="rounded-[30px] bg-press-ink/[0.05] p-[5px] ring-1 ring-inset ring-press-ink/[0.07] sm:rounded-[36px] sm:p-[7px]">
      <div
        className={`rounded-[25px] px-5 py-12 text-white shadow-[inset_0_1px_0_rgba(255,255,255,0.08)] sm:rounded-[29px] sm:px-10 sm:py-14 lg:px-14 ${
          night ? 'theme-night' : ''
        } ${className}`}
        style={{
          background:
            'radial-gradient(70% 60% at 85% 0%, rgba(255,255,255,0.07), transparent 70%), radial-gradient(60% 50% at 0% 100%, rgba(255,255,255,0.04), transparent 70%), #0B0E12',
        }}
      >
        {children}
      </div>
    </div>
  );
}
